import React, { Component } from 'react'
import { Link } from 'react-router'
import GenericEvent from './GenericEvent'

const CAMPAIGN_ICON_SRC = require('images/svg/megaphone-navy.svg')
const ActionMap = {
  MESSAGE_CTA_CLICKED: 'clicked on CTA in',
  MESSAGE_SEEN: 'opened',
  MESSAGE_SENT: 'received'
}

export default class MessageCampaignEvent extends Component {
  render() {
    const { event: { body: { campaign }}} = this.props
    const action = ActionMap[this.props.event.eventType]
    const eventProps = {
      iconSrc: CAMPAIGN_ICON_SRC,
      eventLabel: `${action} campaign`,
      ...this.props
    }
    return (
      <GenericEvent {...eventProps }>
        {campaign &&
          (<Link to={`/campaigns/${ campaign.id }`}>{campaign.name}</Link>)}
      </GenericEvent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/MessageCampaignEvent.js